import { useState, useEffect } from "react";
import { commonAPI } from "../../../../services/CommonAPIService"; 

const Document = ({ selectedDocument, setSelectedDocument }) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

useEffect(() => {
  const fetchDocuments = async () => {
    const auth = localStorage.getItem("userData");
    if (!auth) return;

    let myUserData;

    try {
      myUserData = JSON.parse(auth);
    } catch (parseErr) {
      console.error("Invalid userData in localStorage", parseErr);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await commonAPI(
        "DocumentMasterService",
        undefined,
        { buildingId: myUserData?.buildingId }
      );

      if (response?.success === true && Array.isArray(response.data)) {
        const formattedDocs = response.data
          .filter((item) => item.isActive !== false)
          .map((item) => ({
            id:
              item.docId?.toString() ||
              item.docCode ||
              `doc-${Math.random().toString(36).slice(2)}`,
            label: item.docName || "Unnamed Document",
            image: item.thumbnailImageURL || null,
            code: item.docCode,
            type: item.docType,
            subType: item.docSubType,
          }));

        setDocuments(formattedDocs);
      } else {
        setError(response?.message || "Failed to load document types");
      }
    } catch (err) {
      console.error("Error fetching document master:", err);

      const bodyError = {
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: null,
        uri: "api/Master/DocumentMaster/Identity",
        errorSource: "CuroNextPortal",
        errorNumber: "DOCMF01",
        errorSummary: err?.message,
        errorDescription: JSON.stringify(err),
        fileClassName: "Document.js",
        functionName: "fetchDocuments",
      };

      try {
        await commonAPI("ErrorLogMaster", bodyError);
      } catch (logErr) {
        console.error("Error while logging error:", logErr);
      }

      setError("Unable to load document types. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  fetchDocuments();
}, []);

  const handleSelect = (doc) => {
    setSelectedDocument(doc);
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading documents...</span>
        </div>
        <p className="mt-2 text-muted">Loading document types...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-warning text-center py-4">
        {error}
        <br />
        <small className="text-muted">You may continue without selecting a document type.</small>
      </div>
    );
  }

  if (documents.length === 0) {
    return (
      <div className="alert alert-info text-center py-4">
        No document types available at the moment.
      </div>
    );
  }

  return (
    <>
    <div className="d-flex justify-content-center mb-3">
    <label className="form-label fw-bold mb-2">Select Document Type</label>

  </div>

      <div className="row g-3">
        {documents.map((doc) => {
          const active = selectedDocument?.id === doc.id;

          return (
            <div className="col-6" key={doc.id}>
              <div
                onClick={() => handleSelect(doc)}
                style={{
                  // background: "#F3F8FF",
                  background:active ?"#F3F8FF":"#FFFFFF",
                  height: 140,
                  borderRadius: 12,
                  cursor: "pointer",
                  border: active ? "2px solid #CDDEFF" : "1px solid #D4D4D4",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 500,
                  padding: 10,
                  transition: "all 0.2s",
                }}
                className="hover-shadow" 
              >
                <div style={{ fontSize: 14, marginBottom: 8, textAlign: "center" }}>
                  {doc.label}
                </div>

                {doc.image ? (
                  <img
                    src={doc.image}
                    alt={doc.label}
                    style={{
                      maxWidth: "80%",
                      maxHeight: "70%",
                      objectFit: "contain",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none"; 
                      e.target.nextSibling.style.display = "flex"; 
                    }}
                  />
                ) : null}

                {!doc.image && (
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      background: "rgba(0,0,0,0.08)",
                      borderRadius: 8,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 12,
                      color: "#666",
                    }}
                  >
                    No Image
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Document;